import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const summonRoomSystem = async ({
  sessionId,
  roomSystemId,
}: {
  sessionId: string;
  roomSystemId: string;
}): Promise<void> => {
  const response = await axiosClient.post(
    `/sessions/${sessionId}/room-system/${roomSystemId}`,
  );
  return response.data;
};

export function useSummonRoomSystem(
  mutationOptions?: Partial<
    UseMutationOptions<
      void,
      HttpError,
      { sessionId: string; roomSystemId: string }
    >
  >,
) {
  return useMutation({
    mutationFn: ({ sessionId, roomSystemId }) =>
      summonRoomSystem({ sessionId, roomSystemId }),
    ...mutationOptions,
  });
}
